import omit from 'lodash/omit';

/* 表单联动相关方法 */
const compareType = {
    eq: '==',
    notEq: '!==',
    nullValue: '==',
    notNullValue: '=='
};

/* 表单联动规则format */
export function assembleExpressions(rules, isEditForm) {
    const sources = [];
    const watchFields = [];
    let newRules = this.combineArray(rules);
    if (!isEditForm) {
        newRules.forEach(rule => {
            const source = {
                source:
                    'if (event.isFieldValueChanged(["' +
                    rule.aclField.replace('\\', '\\\\') +
                    '"])) {' +
                    (rule.refreshFields.length > 0
                        ? this.formatRefresh(rule.refreshFields)
                        : '') +
                    (rule.relyField.length > 0 ? this.formatRely(rule) : '') +
                    '}'
            };
            sources.push(source);
            watchFields.push(rule.aclField);
        });
    } else {
        newRules.forEach(rule => {
            if (rule.aclType == 'setStatus') return false;
            const source = {
                source:
                    rule.refreshFields.length > 0
                        ? this.formatRefresh(rule.refreshFields, true)
                        : ''
            };
            sources.push(source);
            watchFields.push(rule.aclField);
        });
    }
    return [sources, watchFields];
}

/* 合并相同字段的联动规则 */
export function combineArray(rules) {
    let map = {},
        dest = [];
    for (let i = 0; i < rules.length; i++) {
        let ai = rules[i];
        if (!map[ai.aclField]) {
            dest.push({
                aclField: ai.aclField,
                aclType: ai.aclType,
                refreshFields: ai.refreshFields,
                relyField: ai.relyField
            });
            map[ai.aclField] = ai;
        } else {
            for (let j = 0; j < dest.length; j++) {
                let dj = dest[j];
                if (dj.aclField == ai.aclField) {
                    dj.refreshFields = dj.refreshFields.concat(
                        ai.refreshFields
                    );
                    dj.relyField = dj.relyField.concat(ai.relyField);
                    break;
                }
            }
        }
    }
    return dest;
}

/* format字段刷新数据源规则 */
export function formatRefresh(fields, isEditInit) {
    return fields
        .map(field => {
            return isEditInit
                ? `__builtin.collect(ui.field.setDataSourceAsync("${field.replace(
                      '\\',
                      '\\\\'
                  )}",__builtin.FormMetaData));`
                : `__builtin.collect(ui.field.setDataSourceAsync("${field.replace(
                      '\\',
                      '\\\\'
                  )}",__builtin.FormMetaData));__builtin.collect(ui.field.clearFieldValue("${field.replace(
                      '\\',
                      '\\\\'
                  )}",__builtin.FormMetaData));`;
        })
        .join('');
}

/* format字段设置显隐必填规则(待优化) */
export function formatRely(rule) {
    return rule.relyField
        .map(field => {
            return (
                'if (' +
                this.formatValue(field, rule.aclField) +
                ') {' +
                field.displayContent.fields
                    .map(field => {
                        return (
                            '__builtin.collect(ui.field.setEditable("' +
                            field.replace('\\', '\\\\') +
                            '",__builtin.FormMetaData));'
                        );
                    })
                    .join('') +
                field.displayContent.parts
                    .map(field => {
                        return (
                            '__builtin.collect(ui.formpart.setFormPartEdit("' +
                            field.replace('\\', '\\\\') +
                            '",__builtin.FormMetaData));'
                        );
                    })
                    .join('') +
                field.hideContent.fields
                    .map(field => {
                        return (
                            '__builtin.collect(ui.field.hide("' +
                            field.replace('\\', '\\\\') +
                            '",__builtin.FormMetaData));'
                        );
                    })
                    .join('') +
                field.hideContent.parts
                    .map(field => {
                        return (
                            '__builtin.collect(ui.formpart.hiddenFormPart("' +
                            field.replace('\\', '\\\\') +
                            '",__builtin.FormMetaData));'
                        );
                    })
                    .join('') +
                field.requiredFields
                    .map(field => {
                        return (
                            '__builtin.collect(ui.field.setRequired("' +
                            field.replace('\\', '\\\\') +
                            '",__builtin.FormMetaData));'
                        );
                    })
                    .join('') +
                field.notRequiredFields
                    .map(field => {
                        return (
                            '__builtin.collect(ui.field.setNotRequired("' +
                            field.replace('\\', '\\\\') +
                            '",__builtin.FormMetaData));'
                        );
                    })
                    .join('') +
                '}'
            );
        })
        .join('');
}

/* format显隐必填规则中的value */
export function formatValue(field, aclField) {
    let formatValue = '';
    if (field.value.length !== 0) {
        for (let i = 0; i < field.value.length; i++) {
            formatValue =
                formatValue +
                'ui.field.getFieldValue("' +
                aclField.replace('\\', '\\\\') +
                '", __builtin.FormMetaData) ' +
                compareType[field.compareType] +
                '"' +
                field.value[i] +
                (field.compareType == 'eq'
                    ? '"||'
                    : field.compareType == 'notEq'
                    ? '"&&'
                    : null);
        }
        formatValue = formatValue.substr(0, formatValue.length - 2);
    } else {
        formatValue =
            'ui.field.getFieldValue("' +
            aclField.replace('\\', '\\\\') +
            '", __builtin.FormMetaData) ' +
            (field.compareType == 'nullValue' ? '==""' : '!==""');
    }
    return formatValue;
}

function getBizData(bizData) {
    if (!bizData || !bizData._id) {
        return {};
    }
    let data = [
        {
            ids: bizData._id.value,
            id: bizData._id.value,
            _id: bizData._id.value
        }
    ];
    Object.keys(bizData).map(key => {
        data[key] = bizData[key].value;
    });
    return data;
}

// get query object
function getPureQueryObject(url, sign) {
    if (!url) {
        url = location.hash;
    }
    let hash = url.replace(/^(.+)\?(.+)$/gi, '$2').split('&');
    let obj = {};
    hash.map(query => {
        let couple = query.split('=');
        obj[couple[0]] = couple[1];
    });
    if (!sign) {
        delete obj.shadow_context;
        delete obj._pt;
        delete obj._ptid;
    }
    return omit(obj, ['_k']);
}

export function templateReplace(template, data) {
    template = template || '';
    let targets = template.match(/{([^{}]+)}/g) || [];
    let final = template;
    targets.map(x => {
        // get value from data
        let node = x
            .replace('{', '')
            .replace('}', '')
            .split('.');
        let value = JSON.parse(JSON.stringify(data));
        for (let i = 0; i < node.length; i++) {
            value = value[node[i]];
            if (!value) {
                break;
            }
        }
        // replace
        value && (final = final.replace(x, value));
    });
    return final;
}

/**
 * 获取联动刷新数据源refreshParams参数内容
 * @param template
 * @param formMetaData {FormComponent}
 * @param metaObjectContext
 * @param bizData {BizData}
 */
export function getRefreshParams(
    template,
    formMetaData,
    metaObjectContext,
    bizData
) {
    // let formData = formMetaData.toJS();
    // let params = formData.popOptions.__params;
    let _context = {
        metaObjName: formMetaData.cmp_data.metaObjectName,
        viewName: formMetaData.cmp_data.viewName,
        metaObjId: formMetaData.cmp_data.context._metaObjID
    };
    let dataSource = Object.assign(
        {
            formData: getBizData(bizData)[0],
            context: _context,
            formContext: _context,
            params: metaObjectContext,
            queryUrl: getPureQueryObject()
        },
        _context
    );
    return templateReplace(template, dataSource);
}



// WEBPACK FOOTER //
// ./src/components/util/fieldLinkageUtils.js